import styled from "styled-components";
import { ListItem, ListItemText, ListItemIcon, Grid, Typography } from "@material-ui/core";
import ListIcon from "@material-ui/icons/FiberManualRecord";
import HelpIcon from "@material-ui/icons/LiveHelp";

export const STIconGrid = styled.div`
  && {
    display: flex;
    align-items: center;
    cursor: pointer;
    width: fill-content;
    color: #245c9c;
  }
`;

export const STTitleTypography = styled(Typography)`
  &&& {
    font-weight: 600;
    font-size: 1rem;
    padding-bottom: 1rem;
  }
`;

export const STHelpIcon = styled(HelpIcon)`
  && {
    margin-left: 8px;
    margin-right: 5px;
    height: 20px;
    wight: 20px;
  }
`;

export const STListItem = styled(ListItem)`
  && {
    padding-bottom: 0;
    padding-top: 0;
  }
`;

export const STListItemText = styled(ListItemText)`
  && {
    padding: 0;
    margin: 0;
  }
`;

export const STListItemIcon = styled(ListItemIcon)`
  && {
    margin-right: 8px;
    min-width: 0;
  }
`;

export const STListIcon = styled(ListIcon)`
  && {
    font-size: 8px;
  }
`;
